export var SourceTypes;!function(e){e.STATIC="static",e.RESOLVABLE="resolvable"}(SourceTypes||(SourceTypes={}));